export const EN_MEMBER_OUTREACH_RECOMMENDATIONS_STRINGS = {
  RECOMMENDATIONS: 'Recommendations',
  RECOMMENDATION_CONTENT_SECTION: 'Content',
  RECOMMENDATION_INTERNAL_NAME_LABEL: 'Internal Name',
  RECOMMENDATION_INTERNAL_NAME_HINT:
    'Internal identifier for this catalog entry. Not shown to members; used to find the entry in this list.',
  RECOMMENDATION_TITLE_LABEL: 'Title',
  RECOMMENDATION_TITLE_HINT:
    'Member-facing title rendered on the recommendation card.',
  RECOMMENDATION_DESCRIPTION_LABEL: 'Description',
  RECOMMENDATION_DESCRIPTION_HINT:
    'Member-facing description rendered on the recommendation card.',
  RECOMMENDATION_CTA_LABEL: 'Call to Action',
  RECOMMENDATION_CTA_HINT:
    'Optional call-to-action shown on the recommendation card.',
  RECOMMENDATION_CTA_LABEL_LABEL: 'Label',
  RECOMMENDATION_CTA_LABEL_HINT:
    'Text shown on the call-to-action button (e.g. "Learn more").',
  RECOMMENDATION_CTA_LINK_LABEL: 'Link',
  RECOMMENDATION_CTA_LINK_HINT:
    'Destination the call-to-action navigates to (e.g. /programs/tobacco-cessation).',
  RECOMMENDATION_IMAGE_LABEL: 'Image',
  RECOMMENDATION_IMAGE_HINT:
    'Select an image from Asset Management to display on the recommendation card.',
  RECOMMENDATION_CATEGORY_LABEL: 'Category',
  RECOMMENDATION_CATEGORY_HINT:
    'The kind of content this entry points to. Used by the Recommendation Service when matching candidates.',
  RECOMMENDATION_CATEGORY_PROGRAM: 'Program',
  RECOMMENDATION_CATEGORY_ARTICLE: 'Article',
  RECOMMENDATION_CATEGORY_SERVICE: 'Service',
  RECOMMENDATION_CATEGORY_BENEFIT: 'Benefit',
};
